import { Row } from "../../../../rest/Geotab";

export const getTitle = (row: Row) => row.UnitName ? `${row.Title}, ${row.UnitName}` : row.Title;


// WEBPACK FOOTER //
// ./src/app/components/Pages/SensorsData/utils.ts